export default class TypeGuard {
  public static isNotUndefined<T>(value: T | undefined): value is T {
    return value !== undefined;
  }
}
